import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { agencyApi } from "./agencyApi";
import { formatMoney } from "@/lib/money";
import { STATUS_META } from "./quoteRequestStatus";
import "./agency.css";

// PM Feedback Batch 1, item 1 (2026-09) — "My requests": read-only, scoped to the agency's own
// submissions (agency-facing prices only — see whitelist_agency_quote_request).
export default function MyQuoteRequests() {
  const nav = useNavigate();
  const [items, setItems] = useState(null);

  useEffect(() => {
    agencyApi.myQuoteRequests().then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
  }, []);

  return (
    <div data-testid="agency-my-quote-requests">
      <h1 className="ag-h1" style={{ fontSize: 32, marginBottom: 8 }}>Your Quote Requests</h1>
      <p className="ag-body" style={{ marginBottom: 26, color: "var(--muted)" }}>Every production cost estimate and quote request you've sent NJM, with live status.</p>
      {items === null ? (
        <div className="ag-small" data-testid="agency-my-quote-requests-loading">Loading…</div>
      ) : items.length === 0 ? (
        <div className="ag-empty" data-testid="agency-my-quote-requests-empty">No requests yet. Use "Estimate Production Cost" to send your first one.</div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {items.map((r) => {
            const meta = STATUS_META[r.status] || STATUS_META["Submitted"];
            return (
              <button
                key={r.id} onClick={() => nav(`/agency/quote-requests/${r.id}`)}
                data-testid={`agency-quote-request-row-${r.id}`}
                className="ag-card ag-card-hover"
                style={{ textAlign: "left", cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 16, flexWrap: "wrap", width: "100%" }}
              >
                <div>
                  <div className="ag-h3" style={{ fontSize: 15 }}>{r.working_title || r.production_type}</div>
                  <div className="ag-small" style={{ marginTop: 4 }}>
                    {r.production_type}{r.shoot_location ? ` · ${r.shoot_location}` : ""} · Submitted {r.submitted_at ? new Date(r.submitted_at).toLocaleDateString() : ""}
                  </div>
                </div>
                <div style={{ textAlign: "right" }}>
                  <div className="ag-body" style={{ fontWeight: 600 }}>{r.grand_total != null ? formatMoney(r.grand_total, r.currency) : "Price TBC"}</div>
                  <span className={`ag-pill ${meta.pillClass}`} style={{ marginTop: 6, display: "inline-block" }} data-testid={`agency-quote-request-status-${r.id}`}>{meta.label}</span>
                </div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
